module.exports = __webpack_public_path__ + "img/img13.d2ce21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img13.png
// module id = 189
// module chunks = 0